function renderShoppingTip(node, template, tipData) {
  const { title, message } = tipData
  node.innerHTML = template({
    title,
    message
  })
}

export default renderShoppingTip
